import React, { useEffect, useState } from "react";
import { API_URL } from "../../config";

const EMPTY_FISCAL_DATA = {
  nombreFiscal: "",
  nif: "",
  direccion: "",
  ciudad: "",
  provincia: "",
  codigoPostal: "",
  pais: "",
  emailFacturacion: "",
  telefonoFacturacion: "",
  notas: "",
};

const FIELD_LABELS = {
  nombreFiscal: "Nombre fiscal o razón social",
  nif: "NIF/CIF",
  direccion: "Dirección fiscal",
  ciudad: "Ciudad",
  provincia: "Provincia",
  codigoPostal: "Código postal",
  pais: "País",
  emailFacturacion: "Email de facturación",
  telefonoFacturacion: "Teléfono de facturación",
  notas: "Notas fiscales internas",
};

function mergeFiscalData(data) {
  const source = data && typeof data === "object" ? data : {};
  return Object.fromEntries(
    Object.keys(EMPTY_FISCAL_DATA).map((key) => [
      key,
      typeof source[key] === "string" ? source[key] : "",
    ]),
  );
}

function DatosFiscalesAcademia() {
  const [form, setForm] = useState(EMPTY_FISCAL_DATA);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    fetch(`${API_URL}/api/configuracion/datos-fiscales-academia`, { credentials: "include" })
      .then((res) => {
        if (!res.ok) {
          throw new Error("No se pudieron cargar los datos fiscales.");
        }
        return res.json();
      })
      .then((data) => {
        if (!cancelled) {
          setForm(mergeFiscalData(data));
        }
      })
      .catch(() => {
        if (!cancelled) {
          setError("No se pudieron cargar los datos fiscales.");
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const handleChange = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const handleSave = async () => {
    setSaving(true);
    setMessage("");
    setError("");
    try {
      const res = await fetch(`${API_URL}/api/configuracion/datos-fiscales-academia`, {
        method: "PUT",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        throw new Error(data.error || "No se pudieron guardar los datos fiscales.");
      }
      setForm(mergeFiscalData(data.datosFiscalesAcademia));
      setMessage("Datos fiscales guardados correctamente.");
    } catch (err) {
      setError(err.message || "No se pudieron guardar los datos fiscales.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <section className="cfgx-section cfgx-section--academy-fiscal">
      <h2>Datos fiscales de la academia</h2>
      <p className="cfgx-help">
        Gestiona los datos fiscales propios de la academia. Esta información no modifica los datos personales de tu cuenta.
      </p>

      <div className="cfgx-form-grid">
        {Object.keys(FIELD_LABELS).map((key) => (
          <div className="cfgx-field" key={key}>
            <label htmlFor={`academy-fiscal-${key}`}>{FIELD_LABELS[key]}</label>
            {key === "direccion" || key === "notas" ? (
              <textarea
                id={`academy-fiscal-${key}`}
                className="cfgx-textarea"
                rows={key === "notas" ? 4 : 3}
                value={form[key]}
                onChange={(e) => handleChange(key, e.target.value)}
              />
            ) : (
              <input
                id={`academy-fiscal-${key}`}
                type={key === "emailFacturacion" ? "email" : "text"}
                className="cfgx-input"
                value={form[key]}
                onChange={(e) => handleChange(key, e.target.value)}
              />
            )}
          </div>
        ))}
      </div>

      <div className="cfgx-form-actions cfgx-form-actions--fiscal">
        {error ? <p className="cfgx-error">{error}</p> : null}
        {message ? <p className="cfgx-msg">{message}</p> : null}
        <button type="button" className="cfgx-btn-guardar" onClick={handleSave} disabled={saving}>
          {saving ? "Guardando..." : "Guardar datos fiscales"}
        </button>
      </div>
    </section>
  );
}

export default DatosFiscalesAcademia;
